import { BillingMetricConsumption } from '../metrics/BillingMetricConsumption';

export class MonthlyMeuConsumption {
  botName!: string;
  botIdentity!: string;
  metricConsumption!: BillingMetricConsumption[];

  constructor(monthlyMeuConsumption: Partial<MonthlyMeuConsumption>) {
    Object.assign(this, monthlyMeuConsumption);
  }
}
